var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 61,
    viewBox: "0 0 50 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2199 32.2587C41.2803 27.576 43.795 23.1452 47.7844 20.6925C45.2677 17.0982 41.0522 14.8192 36.6665 14.682C31.9888 14.191 27.4539 17.4811 25.0702 17.4811C22.6404 17.4811 18.9703 14.7308 15.0182 14.8121C9.86689 14.9785 5.06454 17.9073 2.55831 22.4109C-2.82911 31.7384 1.18942 45.4467 6.35011 52.9863C8.93212 56.6782 11.9497 60.8022 15.8982 60.656C19.7621 60.4957 21.2052 58.1921 25.8691 58.1921C30.4898 58.1921 31.8437 60.656 35.8724 60.563C40.0184 60.4957 42.6307 56.8546 45.1221 53.1277C46.9773 50.4971 48.4048 47.5897 49.3519 44.5131C44.4794 42.4523 41.2256 37.549 41.2199 32.2587Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6105 9.72359C35.8711 7.0098 36.9848 3.52169 36.7151 0C33.2614 0.362747 30.0711 2.0134 27.78 4.62307C25.5396 7.17285 24.3736 10.5996 24.594 13.9867C28.049 14.0222 31.4455 12.4163 33.6105 9.72359Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/appleLogo.db0fad98b8163baf3da96bb420b5e974.svg";
export { ForwardRef as ReactComponent };